module.exports = __webpack_public_path__ + "static/item-template-calendar-name-6b5829ceac02e5445b29fbcc61f00ee7.png";